import React, { useState } from "react";
import './MultiTagInput.css';

const MultiTagInput = ({ options, onTagsChange }) => {
    const [tags, setTags] = useState([]);
    const [inputValue, setInputValue] = useState("");

    const handleAddTags = (value) => {
        // Only add tags that are not empty, not duplicates, and are trimmed
        const newTags = value
            .split(/, */) // Split tags by commas, but keep spaces inside tags
            .map((tag) => tag.trim())
            .filter((tag) => tag && !tags.includes(tag)); // Avoid empty and duplicate tags

        if (newTags.length > 0) {
            const updatedTags = [...tags, ...newTags];
            setTags(updatedTags);
            setInputValue("");
            if (onTagsChange) {
                onTagsChange(updatedTags); // Notify parent about the updated tags
            }
        }
    };

    const handleRemoveTag = (tagToRemove) => {
        const updatedTags = tags.filter((tag) => tag !== tagToRemove);
        setTags(updatedTags);
        if (onTagsChange) {
            onTagsChange(updatedTags); // Notify parent about the updated tags
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") { //|| e.key === "Tab"
            e.preventDefault();
            handleAddTags(inputValue);
        }
    };

    const handleBlur = () => {
        if (inputValue.trim()) {
            handleAddTags(inputValue);
        }
    };

    return (
        <>
            <label htmlFor="warehouse" className="mb-1 text-sm font-semibold">Tag</label>
            <div className="multi-tag-input my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200">
                <div className="tags-container">
                    {tags?.map((tag, index) => (
                        <span key={index} className="tag">
                            {tag}
                            <button
                                type="button"
                                className="remove-tag"
                                onClick={() => handleRemoveTag(tag)}
                            >
                                &times;
                            </button>
                        </span>
                    ))}
                    <input
                        type="text"
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                        onKeyDown={handleKeyDown}
                        onBlur={handleBlur}
                        placeholder="Add tags (comma separated)..."
                        className="tag-input-field"
                        list="tag-options"
                    />
                    <datalist id="tag-options">
                        {options.map((option, index) => (
                            <option key={index} value={option} />
                        ))}
                    </datalist>
                </div>
            </div>
        </>
    );
};

export default MultiTagInput;
